<template>
    <!-- Momento 2 es reclamo -->
    <!-- solo para el módulo Soporte -->
    <chat
    :desfase="0"
    :momento="1"
    finalizado
    :limitar-mensajes="false"
    :tipo="2"
    :user="detalle.id_pedido"
    :fecha-finalizado="detalle.fecha_finalizado_chat_cliente"
    />
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    computed:{
        ...mapGetters({
            detalle: 'pedidos/pedidos_admin/pedido',
        }),

    },

}
</script>

<style lang="css" scoped>
</style>
